module.exports = __webpack_public_path__ + "img/gf@2x.a063bee0.png";